export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/9efedd6f8d84b8cf11b1862201b47d04.svg";